export default __webpack_public_path__ + "67e0b77bc58f8a763342196ca5d3c883.png";